export const CONTACT_AGREEMENT = "contactAgreementReport";
export const LOGIN_HISTORY = "loginHistoryReport";
export const OPERATION_HISTORY = "operationHistoryReport";
export const CONTACT_QUARANTINE = "contactQuarantineReport";
